export const API_URL = "https://rv5vbbq7x8.execute-api.eu-central-1.amazonaws.com";
export const API_KEY = "8a2ca129-20da-430d-8eb2-62545f46a541";

